
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Boxes, Search } from "lucide-react";

// Mock data
const stockData = [
  {
    id: 1,
    name: "Organic Brown Rice 1kg",
    sku: "BR001",
    supplier: "EcoFarms",
    category: "Grains",
    posQty: 45,
    onlineQty: 40,
    reservedQty: 3,
    threshold: 10,
    suggestion: 30,
    lastUpdate: "2025-05-11T14:30:00",
  },
  {
    id: 2,
    name: "Fresh Milk 1L",
    sku: "FM001",
    supplier: "Dairy Fresh",
    category: "Dairy",
    posQty: 12,
    onlineQty: 8,
    reservedQty: 2,
    threshold: 15,
    suggestion: 25,
    lastUpdate: "2025-05-12T09:15:00",
  },
  {
    id: 3,
    name: "Whole Wheat Bread",
    sku: "WB001",
    supplier: "Healthy Bakery",
    category: "Bakery",
    posQty: 8,
    onlineQty: 5,
    reservedQty: 0,
    threshold: 10,
    suggestion: 20,
    lastUpdate: "2025-05-12T08:45:00",
  },
  {
    id: 4,
    name: "Free-Range Eggs (Dozen)",
    sku: "EG001",
    supplier: "Happy Farms",
    category: "Dairy",
    posQty: 18,
    onlineQty: 15,
    reservedQty: 1,
    threshold: 8,
    suggestion: 15,
    lastUpdate: "2025-05-11T16:20:00",
  },
  {
    id: 5,
    name: "Instant Coffee 200g",
    sku: "IC001",
    supplier: "BeanMaster",
    category: "Beverages",
    posQty: 6,
    onlineQty: 4,
    reservedQty: 1,
    threshold: 5,
    suggestion: 10,
    lastUpdate: "2025-05-10T11:30:00",
  },
];

const StockLevelsTab = () => {
  const [searchTerm, setSearchTerm] = useState("");
  
  const filteredStockData = stockData.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.sku.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.supplier.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(date);
  };
  
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold">Stock Levels</h2>
        <div className="flex gap-2">
          <div className="relative">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search products..."
              className="pl-8 w-[250px]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Button variant="outline">
            <Boxes className="mr-2 h-4 w-4" />
            Export
          </Button>
        </div>
      </div>
      
      <div className="border rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Product Name</TableHead>
              <TableHead>SKU / Barcode</TableHead>
              <TableHead>Supplier</TableHead>
              <TableHead>Category</TableHead>
              <TableHead className="text-center">POS Qty</TableHead>
              <TableHead className="text-center">Online Qty</TableHead>
              <TableHead className="text-center">Reserved</TableHead>
              <TableHead className="text-center">Threshold</TableHead>
              <TableHead className="text-center">Reorder Suggestion</TableHead>
              <TableHead>Last Updated</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredStockData.map((item) => (
              <TableRow key={item.id} className={item.posQty <= item.threshold ? "bg-red-50" : ""}>
                <TableCell className="font-medium">{item.name}</TableCell>
                <TableCell>{item.sku}</TableCell>
                <TableCell>{item.supplier}</TableCell>
                <TableCell>{item.category}</TableCell>
                <TableCell className="text-center">{item.posQty}</TableCell>
                <TableCell className="text-center">{item.onlineQty}</TableCell>
                <TableCell className="text-center">{item.reservedQty}</TableCell>
                <TableCell className="text-center">{item.threshold}</TableCell>
                <TableCell className="text-center">{item.suggestion}</TableCell>
                <TableCell>{formatDate(item.lastUpdate)}</TableCell>
                <TableCell className="text-right">
                  <Button size="sm">Set Threshold</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default StockLevelsTab;
